import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { useStores } from 'presentation/hooks/use-stores'
import SchedulingSectorOrdersDataGrid from 'presentation/hospital/components/Tables/SchedulingSectorOrdersDataGrid'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import * as S from './styles'
import {
  SchedulingStatus,
  SchedulingStatusLocated
} from 'common/enum/scheduling-status'
import { useCreateSurgicalSchedulingContext } from '../context-create-surgical-scheduling'

type SchedulingSectorOrdersLayoutProps = {
  status?: SchedulingStatus
}

const SchedulingSectorOrdersLayout = observer(
  ({ status }: SchedulingSectorOrdersLayoutProps) => {
    const { dispatch } = useCreateSurgicalSchedulingContext()
    const currentHospital = useStores().currentHospital.actualHospital
    const [titleStatus, setTitleStatus] = useState<SchedulingStatus>(
      status ?? SchedulingStatus.ALL
    )

    useEffect(() => {
      dispatch({
        type: 'RESET_SURGICAL_SCHEDULING'
      })
    }, [])

    return (
      <S.Wrapper>
        <HeadingNew size="xlarge" color="secondary700">
          {SchedulingStatusLocated[titleStatus]}
        </HeadingNew>
        <SchedulingSectorOrdersDataGrid
          currentHospitalId={currentHospital!.hospital_id}
          status={status}
          setTitleStatus={setTitleStatus}
        />
      </S.Wrapper>
    )
  }
)

export default SchedulingSectorOrdersLayout
